'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M895.772 128c0.078 0.066 0.162 0.15 0.228 0.23v767.542c-0.066 0.078-0.15 0.162-0.228 0.228h-767.544c-0.080-0.066-0.162-0.15-0.228-0.228v-767.544c0.066-0.080 0.15-0.162 0.23-0.228h767.542zM896 0h-768c-70.4 0-128 57.6-128 128v768c0 70.4 57.6 128 128 128h768c70.4 0 128-57.6 128-128v-768c0-70.4-57.6-128-128-128v0z' }),
        React.createElement('path', { d: 'M672 256l-160 160-160-160-96 96 160 160-160 160 96 96 160-160 160 160 96-96-160-160 160-160z' })
    ));
};